import { TReduxActions } from '../../actions';
import { ESearchResultsActionType } from '../../actions/searchResults';
import { ISearchResults } from '../../types/searchResults';

const defaultState: ISearchResults = {
  isOpen: false,
  isReady: false,
  url: '',
  isDotPin: undefined,
};

export function searchResultsReducer(state: ISearchResults = defaultState, action: TReduxActions): ISearchResults {
  switch (action.type) {
    case ESearchResultsActionType.SidebarOpened:
      return {
        ...state,
        isOpen: true,
        isDotPin: action.payload ?? undefined,
      };
    case ESearchResultsActionType.SidebarClosed:
      return {
        ...state,
        isOpen: false,
        isDotPin: undefined,
      };
    case ESearchResultsActionType.UrlChanged:
      return {
        ...state,
        url: action.payload,
      };
    case ESearchResultsActionType.SidebarReady:
      return {
        ...state,
        isReady: action.payload,
      };
  }

  return state;
}
